export default {
  send (VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken
    VueApp.$sdk.post('/consumer/notification', data, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/notifications.js